import hero1 from '#/assets/home/hero1.webp'
import hero2 from '#/assets/home/hero2.webp'
import hero3 from '#/assets/home/hero3.webp'
import hero1Mobile from '#/assets/home/hero1-mobile.webp'
import hero2Mobile from '#/assets/home/hero2-mobile.webp'
import hero3Mobile from '#/assets/home/hero3-mobile.webp'
import foregroundImage1 from '#/assets/home/foreground-image1.webp'
import foregroundImage2 from '#/assets/home/foreground-image2.webp'
import foregroundImage3 from '#/assets/home/foreground-image3.webp'

export interface HeroSlide {
  title: string
  description: string
  background: string
  backgroundMobile: string
  foreground: string
  foregroundAlt: string
}

export const HERO_SLIDES: HeroSlide[] = [
  {
    title: 'Start Your Quran Journey Today',
    description:
      'Learn the Quran with qualified teachers who understand the needs of non-Arabic speakers. Start with a free trial lesson and discover a personalized learning path designed around your level and goals.',
    background: hero3,
    backgroundMobile: hero3Mobile,
    foreground: foregroundImage1,
    foregroundAlt: 'Online Quran course materials',
  },
  {
    title: 'Learn the Quran. Understand. Grow.',
    description:
      'From Quran reading and Tajweed to memorization and Islamic studies, our structured lessons help you build confidence, improve your recitation, and develop a lasting connection with the Quran.',
    background: hero2,
    backgroundMobile: hero2Mobile,
    foreground: foregroundImage2,
    foregroundAlt: 'Student reading Quran in a mosque',
  },
  {
    title: 'A Learning Path Made for You',
    description:
      "Whether you are a beginner, a parent looking for Quran lessons for your children, or a student seeking to improve your recitation, Wa'allamah Institute provides flexible one-on-one learning with a qualified tutor.",
    background: hero1,
    backgroundMobile: hero1Mobile,
    foreground: foregroundImage3,
    foregroundAlt: 'Tutor guiding a Quran class online',
  },
]

export const HERO_CTA_LABEL = 'Book Your Free Class'
